import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-nail-color"
    path="business/products/ai-nail-color"
    element={<AsyncPage />}
  />,
];
